import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const DUAL_GUARDED_ACTION_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  EXPIRED: 3,
  CANCELLED: 4
}

export const DUAL_GUARDED_ACTION_STATUS_MAP = {
  [DUAL_GUARDED_ACTION_STATUS.PENDING]: t('constants.dual_guarded_action_status.pending'),
  [DUAL_GUARDED_ACTION_STATUS.APPROVED]: t('constants.dual_guarded_action_status.approved'),
  [DUAL_GUARDED_ACTION_STATUS.REJECTED]: t('constants.dual_guarded_action_status.rejected'),
  [DUAL_GUARDED_ACTION_STATUS.EXPIRED]: t('constants.dual_guarded_action_status.expired'),
  [DUAL_GUARDED_ACTION_STATUS.CANCELLED]: t('constants.dual_guarded_action_status.cancelled')
}

export const DUAL_GUARDED_ARCHIVED_STATUSES = [
  DUAL_GUARDED_ACTION_STATUS.APPROVED,
  DUAL_GUARDED_ACTION_STATUS.REJECTED,
  DUAL_GUARDED_ACTION_STATUS.EXPIRED,
  DUAL_GUARDED_ACTION_STATUS.CANCELLED
]
